<template>
  <div
    class="d-flex align-items-start"
    :class="[ 'header__' + name, sortable ? 'sortable' : '' ]"
  >
    <span><slot /></span>
    <span
      v-if="sortable"
      class="carret"
      :class="{'carret-up': !sortingActive || sortingDir === '+', 'carret-down': !sortingActive || sortingDir === '-'}"
    />
  </div>
</template>

<script setup lang="ts">
withDefaults(defineProps<{
  name: string
  sortable?: boolean
  sortingActive?: boolean
  sortingDir?: '-' | '+'
}>(), {
  name: '-',
  sortable: false,
  sortingActive: false,
  sortingDir: '-'
})
</script>
